import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Container,
  Button,
  makeStyles,
  Card,
  CardMedia,
  Paper,
} from '@material-ui/core';

import firebase from '../firebase/firebaseConfig';
// import { Paper, Button } from '@material-ui/core';
import Carousel from 'react-material-ui-carousel';
import logo from '../assets/LOGO_THUMBNAIL.jpg';
import backgroundWavey from '../assets/Wavey-Fingerprint.svg';
import croptop from '../assets/sld_croptop.jpg';
import iphone from '../assets/sld_iphone.png';
import tshirt from '../assets/sld_tshirt.png';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'fixed',
    left: 0,
    right: 0,
    zIndex: 9999,
  },
  card: {
    marginTop: '15%',
  },
  media: {
    width: '60px',
    height: '60px',
    margin: '15px auto 15px auto',
  },
  button: {
    display: 'block',
    margin: '20px auto 30px auto',
  },

  backgroundImage: {
    position: 'fixed',
    left: 0,
    right: 0,
    zIndex: '1',

    backgroundImage: `url(${backgroundWavey})`,

    width: '100%',
    height: '100%',
    display: 'block',
    // filter: 'blur(5px)',
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  carouselImage: {
    height: '35vh',
    padding: '5px',
  },
}));

const Home = () => {
  const classes = useStyles();

  const [userUID, setUserUID] = useState('');

  useEffect(() => {
    const unsubscribe = firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        // User is signed in, see docs for a list of available properties
        // https://firebase.google.com/docs/reference/js/firebase.User
        setUserUID(user.uid);
        // ...
      } else {
        // User is signed out
        setUserUID(null);
      }
    });

    return () => unsubscribe();
  }, []);

  const items = [
    {
      image: croptop,
      linkTo: 'https://savannahlatindance.com/shop/product/227083759',
    },
    {
      image: iphone,
      linkTo: 'https://savannahlatindance.com/shop/product/226527608',
    },
    {
      image: tshirt,
      linkTo: 'https://savannahlatindance.com/shop/product/227084284',
    },
  ];

  return (
    <div>
      <div className={classes.backgroundImage}></div>
      <Container
        className={classes.root}
        maxWidth='sm'
        options={{
          fullWidth: true,
          indicators: true,
        }}
      >
        <Card className={classes.card}>
          <Carousel className={classes.carousel}>
            {items.map((item, i) => (
              <a key={i} href='https://savannahlatindance.com/'>
                <Item item={item} />
              </a>
            ))}
          </Carousel>
          <Link
            to={
              userUID
                ? { pathname: '/account', state: { userUID } }
                : { pathname: '/sign', state: { lang: 'en' } }
            }
          >
            <Button
              className={classes.button}
              size='large'
              variant='contained'
              color='primary'
            >
              English
            </Button>
          </Link>
          <Link
            to={
              userUID
                ? { pathname: '/account', state: { userUID } }
                : { pathname: '/sign', state: { lang: 'es' } }
            }
          >
            <Button
              className={classes.button}
              size='large'
              variant='contained'
              color='primary'
            >
              Español
            </Button>
          </Link>
          <CardMedia className={classes.media} image={logo} title='SLD Logo' />
        </Card>
      </Container>
    </div>
  );
};

export default Home;

function Item(props) {
  const classes = useStyles();
  return (
    <Paper className={classes.paper}>
      <img
        alt={'Product from merchandise store'}
        className={classes.carouselImage}
        src={props.item.image}
      />
      {/* <Button className='CheckButton'>Check it out!</Button> */}
    </Paper>
  );
}
